import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Radio.module.scss'

type RadioProps = FormFieldBaseProps & {
  placeholder?: string
  value?: boolean
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => {
    return (
      <input
        className={cx(styles.radio, fieldClassName, {
          [styles.invalid]: Boolean(error),
        })}
        type="radio"
        checked={value}
        disabled={isDisabled}
        required={isRequired}
        {...{ id, name, placeholder, ref, onBlur, onChange }}
      />
    )
  },
)

type ControlledRadioProps = ControlledFieldProps

export const ControlledRadio = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}: ControlledRadioProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Radio
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
